import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

import { Menu } from "antd";

import { setSearchText } from "../../redux/store/common/commonDuck";

const { SubMenu } = Menu;

const SiderComponent = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  // const pathname = window.location.pathname;

  const location = useLocation();

  const setIsSearchText = (value) => dispatch(setSearchText(value));
  const user = useSelector((state) => state.auth.user);
  const menuList = useSelector((state) => state.auth.menu);
  const [openKeys, setOpenKeys] = useState([]);
  const [selectKeys, setSelectKeys] = useState([]);

  const handleOpen = (keys) => {
    const lastOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    // console.log("lastOpenKey", keys, lastOpenKey);
    if (lastOpenKey) {
      setOpenKeys([lastOpenKey]);
    } else {
      setOpenKeys([]);
    }
  };

  useEffect(() => {
    const pathname = location.pathname;
    // console.log("pathname", location.pathname);
    if (pathname !== "/") {
      let menuIdList = menuList?.map((item, idx) => ({
        index: idx,
        subMenuList: item?.subMenuList,
        link_url: item?.subMenuList[0].link_url?.split("/")[1],
      }));
      let filterMenu = menuIdList?.filter((item) =>
        pathname?.split("/")?.[1].includes(item.link_url),
      );
      if (filterMenu?.length) {
        let newOpenKey = `mainMenu_${filterMenu[0]?.index}`;
        if (newOpenKey !== openKeys?.[0]) {
          setOpenKeys([newOpenKey]);
        }
      }
      // console.log(menuIdList, "filterMenu", filterMenu);
      let linkList = filterMenu[0]?.subMenuList?.map((item, idx) => ({
        ...item,
        index: idx,
        // menu_parent: item.menu_parent
      }));
      let filterLink = linkList?.filter((item) => pathname === item.link_url);
      if (filterLink?.length) {
        let newSelectKey =
          filterLink[0]?.menu_parent + "_subMenu_" + filterLink[0]?.index;
        // console.log(newSelectKey !== selectKeys?.[0]);
        if (newSelectKey !== selectKeys?.[0]) {
          setSelectKeys([newSelectKey]);
        }
      }
    } else {
      setOpenKeys([]);
      setSelectKeys([]);
    }
  }, [location]);

  const handleMenuClick = (e) => {
    // console.log(e);
    setIsSearchText("");
    // setSelectKeys([e.key]);
    // setSelectKeys([]);
  };
  return (
    <>
      <Menu
        className="menu-wrap"
        mode="inline"
        style={{ minHeight: "100vh", height: "100%", borderRight: "none" }}
        onOpenChange={handleOpen}
        openKeys={openKeys}
        selectedKeys={selectKeys}
      >
        <div className="almul-admin-wrap" tabIndex="1">
          <img
            className="logo-wrap"
            onClick={() => {
              if (history.location.pathname === "/") {
                history.go(0);
              } else {
                history.push(`/`);
              }
              setIsSearchText("");
            }}
            src={`${process.env.REACT_APP_HOST}/assets/images/main-logo.png`}
          />
          {/*<h1 onClick={() => {*/}
          {/*    history.push(`/`);*/}
          {/*    setIsSearchText("");*/}
          {/*}}>*/}
          {/*    당신의영양제*/}
          {/*</h1>*/}
        </div>
        <div className="plutus-profile-wrap" tabIndex="1">
          <div className={`plutus-profile-img-div`}>
            <img
              className="plutus-profile-img"
              src={
                user && user.profile_url
                  ? `${process.env.REACT_APP_S3_HOST}/image/admin/profile/${user.profile_url}`
                  : `${process.env.REACT_APP_HOST}/assets/images/default-profile.png`
              }
            />
          </div>
          {user && user.nickname && (
            <p className="plutus-profile-name">{user.nickname}</p>
          )}
        </div>
        {menuList && menuList?.length > 0 && (
          // <div className={`sub-menu-title-list`}>
          <>
            {menuList.map((mainMenu, mainIdx) => (
              <SubMenu
                key={"mainMenu_" + mainIdx}
                title={mainMenu.menu_name}
                className={`sub-menu-title-wrap`}
                //  ${history.location.pathname.includes(mainMenu.menu_id?.split("_manage")[0])
                //     ? "ant-menu-submenu-open" : ""}`}
                // onOpenChange={["mainMenu_" + mainMenu.menu_id]}
              >
                {mainMenu?.subMenuList && mainMenu.subMenuList?.length > 0 && (
                  <>
                    {mainMenu.subMenuList?.map((subMenu, subIdx) => (
                      <Menu.Item
                        key={mainMenu.menu_id + "_subMenu_" + subIdx}
                        onClick={handleMenuClick}
                      >
                        <Link to={subMenu.link_url}>{subMenu.menu_name}</Link>
                      </Menu.Item>
                    ))}
                  </>
                )}
              </SubMenu>
            ))}
          </>
        )}
        {/*// <>*/}
        {/*//     <SubMenu key="sub1" title="상품관리" className="sub-menu-title-wrap">*/}
        {/*//         <Menu.Item key="1" onClick={() => setIsSearchText("")}>*/}
        {/*//             <Link to="/product/view">상품*/}
        {/*//                 조회/수정</Link>*/}
        {/*//         </Menu.Item>*/}
        {/*//         <Menu.Item key="2" onClick={() => setIsSearchText("")}*/}
        {/*//         ><Link to="/product/register">상품*/}
        {/*//             등록</Link>*/}
        {/*//         </Menu.Item>*/}
        {/*//     </SubMenu>*/}
        {/*//     <SubMenu key="sub2" title="판매관리" className="sub-menu-title-wrap">*/}
        {/*//         <Menu.Item key="3" onClick={() => setIsSearchText("")}>*/}
        {/*//             <Link*/}
        {/*//                 to="/salesManage/search">주문통합검색</Link>*/}
        {/*//         </Menu.Item>*/}
        {/*//         <Menu.Item key="27" onClick={() => setIsSearchText("")}>*/}
        {/*//             <Link*/}
        {/*//                 to="/salesManage/order/create">전화주문</Link>*/}
        {/*//         </Menu.Item>*/}
        {/*//         <Menu.Item key="4" onClick={() => setIsSearchText("")}>*/}
        {/*//             <Link*/}
        {/*//                 to="/salesManage/order">주문확인</Link>*/}
        {/*//         </Menu.Item>*/}
        {/*//         <Menu.Item key="5" onClick={() => setIsSearchText("")}>*/}
        {/*//             <Link*/}
        {/*//                 to="/salesManage/delivery">배송현황관리</Link>*/}
        {/*//         </Menu.Item>*/}
        {/*//         <Menu.Item key="6" onClick={() => setIsSearchText("")}>*/}
        {/*//             <Link*/}
        {/*//                 to="/salesManage/purchaseComfirmation">구매확정*/}
        {/*//                 내역</Link>*/}
        {/*//         </Menu.Item>*/}
        {/*//         <Menu.Item key="7" onClick={() => setIsSearchText("")}>*/}
        {/*//             <Link*/}
        {/*//                 to="/salesManage/cancel">취소관리</Link>*/}
        {/*//         </Menu.Item>*/}
        {/*//         <Menu.Item key="8" onClick={() => setIsSearchText("")}>*/}
        {/*//             <Link*/}
        {/*//                 to="/salesManage/return">반품관리</Link>*/}
        {/*//         </Menu.Item>*/}
        {/*//         <Menu.Item key="9" onClick={() => setIsSearchText("")}>*/}
        {/*//             <Link*/}
        {/*//                 to="/salesManage/exchange">교환관리</Link>*/}
        {/*//         </Menu.Item>*/}
        {/*//     </SubMenu>*/}
        {/*//     <SubMenu key="sub3" title="문의/리뷰 관리" className="sub-menu-title-wrap">*/}
        {/*//         <Menu.Item key="10" onClick={() => setIsSearchText("")}>*/}
        {/*//             <Link to="/inquiries/product">상품문의*/}
        {/*//                 관리</Link>*/}
        {/*//         </Menu.Item>*/}
        {/*//         <Menu.Item key="23" onClick={() => setIsSearchText("")}>*/}
        {/*//             <Link to="/inquiries/view">추천문의*/}
        {/*//                 관리</Link>*/}
        {/*//         </Menu.Item>*/}
        {/*//         <Menu.Item key="24" onClick={() => setIsSearchText("")}>*/}
        {/*//             <Link to="/inquiries/board">상담게시판*/}
        {/*//                 관리</Link>*/}
        {/*//         </Menu.Item>*/}
        {/*//         <Menu.Item key="12" onClick={() => setIsSearchText("")}>*/}
        {/*//             <Link to="/inquiries/service">서비스문의*/}
        {/*//                 관리</Link>*/}
        {/*//         </Menu.Item>*/}
        {/*//         <Menu.Item key="11" onClick={() => setIsSearchText("")}>*/}
        {/*//             <Link*/}
        {/*//                 to="/inquiries/review">리뷰관리</Link>*/}
        {/*//         </Menu.Item>*/}
        {/*//         <Menu.Item key="99" onClick={() => setIsSearchText("")}>*/}
        {/*//             <Link*/}
        {/*//                 to="/inquiries/gpt">GPT</Link>*/}
        {/*//         </Menu.Item>*/}
        {/*//     </SubMenu>*/}
        {/*//     <SubMenu key="sub4" title="고객 관리" className="sub-menu-title-wrap">*/}
        {/*//         <Menu.Item key="28" onClick={() => setIsSearchText("")}>*/}
        {/*//             <Link*/}
        {/*//                 to="/memberManage/send/sms">문자전송</Link>*/}
        {/*//         </Menu.Item>*/}
        {/*//         <Menu.Item key="29" onClick={() => setIsSearchText("")}>*/}
        {/*//             <Link*/}
        {/*//                 to="/memberManage/crmHistory">CRM 내역</Link>*/}
        {/*//         </Menu.Item>*/}
        {/*//         <Menu.Item key="14" onClick={() => setIsSearchText("")}>*/}
        {/*//             <Link*/}
        {/*//                 to="/memberManage/view">회원관리</Link>*/}
        {/*//         </Menu.Item>*/}
        {/*//     </SubMenu>*/}
        {/*//     <SubMenu key="sub5" title="프로모션" className="sub-menu-title-wrap">*/}
        {/*//         <Menu.Item key="15" onClick={() => setIsSearchText("")}>*/}
        {/*//             <Link to="/promotion/coupon/register">혜택*/}
        {/*//                 등록</Link>*/}
        {/*//         </Menu.Item>*/}
        {/*//         <Menu.Item key="16" onClick={() => setIsSearchText("")}>*/}
        {/*//             <Link to="/promotion/coupon/view">혜택*/}
        {/*//                 발급/조회</Link>*/}
        {/*//         </Menu.Item>*/}
        {/*//         /!*<Menu.Item key="17" onClick={()=>setIsSearchText("")}><Link to="/promotion/">할인코드 등록</Link></Menu.Item>*!/*/}
        {/*//         /!*<Menu.Item key="18" onClick={()=>setIsSearchText("")}><Link to="/promotion/">할인코드 조회</Link></Menu.Item>*!/*/}
        {/*//         /!*<Menu.Item key="19" onClick={()=>setIsSearchText("")}><Link to="/promotion/">시리얼코드 등록</Link></Menu.Item>*!/*/}
        {/*//         /!*<Menu.Item key="20" onClick={()=>setIsSearchText("")}><Link to="/promotion/">시리얼코드 조회</Link></Menu.Item>*!/*/}
        {/*//         /!*<Menu.Item key="21" onClick={()=>setIsSearchText("")}><Link to="/promotion/">리워드 관리</Link></Menu.Item>*!/*/}
        {/*//     </SubMenu>*/}
        {/*//     <SubMenu key="sub7" title="콘텐츠" className="sub-menu-title-wrap">*/}
        {/*//         <Menu.Item key="25" onClick={() => setIsSearchText("")}><Link to="/promotion/content/register">콘텐츠*/}
        {/*//             발행</Link></Menu.Item>*/}
        {/*//         <Menu.Item key="26" onClick={() => setIsSearchText("")}><Link to="/promotion/content/view">콘텐츠*/}
        {/*//             조회/수정</Link></Menu.Item>*/}
        {/*//     </SubMenu>*/}
        {/*//     <SubMenu key="sub6" title="영양제정보관리" className="sub-menu-title-wrap">*/}
        {/*/!*        <Menu.Item key="22" onClick={() => setIsSearchText("")}><Link*!/*/}
        {/*/!*            to="/nutrients/view/certified">영양제정보관리</Link></Menu.Item>*!/*/}
        {/*/!*    </SubMenu>*!/*/}
        {/*/!*    <SubMenu*!/*/}
        {/*/!*        key="insight"*!/*/}
        {/*/!*        title="인사이트"*!/*/}
        {/*/!*        className="sub-menu-title-wrap no-sub-content"*!/*/}
        {/*/!*        onTitleClick={() => history.push(`/insight`)}*!/*/}
        {/*/!*    />*!/*/}
        {/*/!*</>*!/*/}
      </Menu>
    </>
  );
};

export default SiderComponent;
